import { render, staticRenderFns } from "./Marketzodiac.vue?vue&type=template&id=67503f7a&scoped=true&"
import script from "./Marketzodiac.vue?vue&type=script&lang=js&"
export * from "./Marketzodiac.vue?vue&type=script&lang=js&"
import style0 from "./Marketzodiac.vue?vue&type=style&index=0&id=67503f7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67503f7a",
  null
  
)

export default component.exports